import { render, staticRenderFns } from "./OurServiceFixed.vue?vue&type=template&id=31b2a5e2&scoped=true"
import script from "./OurServiceFixed.vue?vue&type=script&lang=js"
export * from "./OurServiceFixed.vue?vue&type=script&lang=js"
import style0 from "./OurServiceFixed.vue?vue&type=style&index=0&id=31b2a5e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b2a5e2",
  null
  
)

export default component.exports